import { createFileRoute } from "@tanstack/react-router"
import { ExternalDataSettingsPage } from "~/components/settings/ExternalDataSettingsPage"

export const Route = createFileRoute("/_auth/settings/_layout/custom-data")({
  component: ExternalDataSettingsPage,
})
